import VideoPlayer from 'app/shared/components/VideoPlayer/VideoPlayer';
import styled, { css } from 'styled-components';
import ImageSlide from 'app/shared/components/MediaGallery/components/MediaSlider/components/ImageSlide/ImageSlide';
import { media } from 'app/styles/variables';
import { IconWrapper } from 'app/shared/components/IconWrapper/IconWrapper';

interface IVideoPlayerStProps {
  show?: boolean;
}

export const VideoPlayerSt = styled(VideoPlayer)<IVideoPlayerStProps>`
  display: none !important;
`;

interface IImageSlideStProps {
  show?: boolean;
}

export const ImageSlideSt = styled(ImageSlide)<IImageSlideStProps>`
  display: ${({ show }) => (show ? 'inline' : 'none')};
`;

export const VideoImageSlideSt = styled(ImageSlide)`
  height: 100%;
`;

export const VideoPlayerContainerSt = styled.div`
  display: flex;
  min-height: 100%;
  align-items: center;
`;

export const VideoSlideIconSt = styled(IconWrapper)`
  position: absolute;
  width: 50px;
  height: 50px;
  top: calc(50% - (50px / 2));
  left: calc(50% - (50px / 2));
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.white};
`;

interface IVideoGalleryContainerStProps {
  offset?: number;
}

export const VideoSlideContainerSt = styled.div<IVideoGalleryContainerStProps>`
  background: white;
  position: relative;
  transition: transform 0.3s;
  transform: ${({ offset }) =>
    `translate(calc(${offset * 100 * -1}% - ${offset * 16}px), 0) `};
  min-width: 80px;
  max-width: auto;
  max-height: 100%;
  ${media.sm(css<IVideoGalleryContainerStProps>`
    transform: ${({ offset }) =>
      `translate(0, calc(${offset * 100 * -1}% - ${offset * 16}px)) `};
    min-height: 80px;
    object-fit: contain;
    background: black;
    max-width: 100%;
    max-height: auto;
  `)}
  &:hover {
    cursor: pointer;
  }
  &:hover span {
    transform: scale(1.5);
    transform-origin: center;
    transition: 0.3s;
  }
`;
